(function(window, document) {
    'use strict'

    document.addEventListener('click', function(event) {
        if (!event.target || typeof event.target.closest !== 'function') {
            return
        }

        const target = event.target.closest('[data-analytics-event]')
        if (!target) {
            return
        }

        if (target.dataset.analyticsEvent === 'phone') {
            window.RT.analytics.track('contacts.phone')
        }

        if (target.dataset.analyticsEvent === 'email') {
            window.RT.analytics.track('contacts.email')
        }
    })

    document.addEventListener('copy', function(event) {
        if (!event.target || typeof event.target.closest !== 'function') {
            return
        }

        const target = event.target.closest('[data-analytics-event]')
        if (!target) {
            return
        }

        if (target.dataset.analyticsEvent === 'phone') {
            window.RT.analytics.track('contacts.phone')
        }

        if (target.dataset.analyticsEvent === 'email') {
            window.RT.analytics.track('contacts.email')
        }
    })
})(window, document)
